import { render, staticRenderFns } from "./ImprimBookHeader.vue?vue&type=template&id=4652780a&scoped=true&"
import script from "./ImprimBookHeader.vue?vue&type=script&lang=js&"
export * from "./ImprimBookHeader.vue?vue&type=script&lang=js&"
import style0 from "./ImprimBookHeader.vue?vue&type=style&index=0&id=4652780a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4652780a",
  null
  
)

export default component.exports